// extracted by mini-css-extract-plugin
export default {"msgM":"_5f441a8bcd"};